import React, { useContext } from 'react';
import { CiLogin, CiLogout } from 'react-icons/ci';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { ICARDIO_AI_LOGO } from '../../constants/images';
import Button from '../Button';
import {
  EmailContainer,
  HeaderContainer,
  HeaderControls,
  HeaderLogo,
  HeaderWrapper,
  IconContainer,
  ToggleContainer,
} from './Header.style';
import { defaultUser, UserContext } from '../../services/contexts';
import Toggle from 'react-toggle';
import { useReviewMode } from 'services/providers';

const Header = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const { user, setUser } = useContext(UserContext);
  const { isReviewMode, setIsReviewMode } = useReviewMode();

  const logOutUser = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(defaultUser);
    navigate('/login');
  };

  const userIsLoggedIn = !!user;

  const handleLogOutOnClick = () => {
    logOutUser();
  };

  const handleToggleReviewMode = () => {
    const nextIsReviewMode = !isReviewMode;
    const nextSearchParams = new URLSearchParams(searchParams);

    if (nextIsReviewMode) nextSearchParams.set('isReviewMode', 'true');
    else nextSearchParams.delete('isReviewMode');

    setIsReviewMode(nextIsReviewMode);
    setSearchParams(nextSearchParams, { replace: true });
  };

  return (
    <HeaderContainer>
      <HeaderWrapper>
        <HeaderLogo>
          <Link to="/">
            <img src={ICARDIO_AI_LOGO} alt="logo" />
          </Link>
        </HeaderLogo>
        <ToggleContainer onClick={handleToggleReviewMode}>
          <div style={{ color: '#fff' }}>Review Mode</div>
          <Toggle checked={isReviewMode} readOnly />
        </ToggleContainer>
        <HeaderControls>
          {userIsLoggedIn ? (
            <>
              <EmailContainer>{user?.profile?.email}</EmailContainer>
              <div onClick={handleLogOutOnClick}>
                <Button
                  buttonType="bordered"
                  label={
                    <IconContainer>
                      <CiLogout /> Log Out
                    </IconContainer>
                  }
                  loading={false}
                  icon={null}
                />
              </div>
            </>
          ) : (
            <Link to="/login">
              <Button
                buttonType="bordered"
                label={
                  <IconContainer>
                    <CiLogin /> Log In
                  </IconContainer>
                }
                loading={false}
                icon={null}
              />
            </Link>
          )}
        </HeaderControls>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

export default Header;
